import { ReactNode } from "react"
import { CartPanel } from "./panels/CartPanel"
import { PlannerPanel } from "./panels/PlannerPanel"
import { AccountPanel } from "./panels/AccountPanel"

export type FlyingCarpetTabInfo = {
  title: string
  component: () => ReactNode
}

export type FlyingCarpetTab = "cart" | "planner" | "account"

export const FLYING_CARPET_PANELS: Record<FlyingCarpetTab, FlyingCarpetTabInfo> = {
  cart: {
    title: "Cart",
    component: CartPanel,
  },
  planner: {
    title: "My Planner",
    component: PlannerPanel,
  },
  account: {
    title: "My Membership",
    component: AccountPanel,
  },
}
